import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import moment from 'moment-timezone';
import i18next from 'i18next';

moment.locale('en-gb');

const getCurrentLocale = () => {
  const lang = i18next.language || 'en-gb';
  if (lang.startsWith('vi')) return 'vi';
  return 'en-gb';
};

// Year & Month Dropdown
class YearMonthForm extends Component {
  static propTypes = {
    date: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    fromMonth: PropTypes.object,
    toMonth: PropTypes.object,
    monthLogic: PropTypes.func,
  }
  static defaultProps = {
    monthLogic: ({ year, month, currentYear, currentMonth }) => (year === currentYear && month > currentMonth),
  };
  constructor(props) {
    super(props);
    const { date } = props;
    this.state = {
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      year: date.getFullYear(),
      month: date.getMonth(),
    };
  }
  componentWillReceiveProps(nextProps) {
    const { date } = nextProps;
    this.setState({
      year: date.getFullYear(),
      month: date.getMonth(),
    });
  }
  handleOnChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      this.handleChange();
    });
  }
  handleChange = () => {
    const { onChange, monthLogic } = this.props;
    const { year, month, currentMonth, currentYear } = this.state;
    if (onChange) {
      if (monthLogic && monthLogic({ year, month, currentMonth, currentYear })) {
        onChange(new Date(year, currentMonth));
        return;
      }
      onChange(new Date(year, month));
    }
  }
  render() {
    const { reff, fromMonth, toMonth, monthLogic } = this.props;
    const { currentMonth, currentYear } = this.state;

    // 2. Automatically grab the active dropdown language context
    const currentLocale = getCurrentLocale();

    const months = [];
    for (let i = 0; i < 12; i += 1) {
      months.push(moment().locale(currentLocale).month(i).format('MMMM'));
    }

    const years = [];
    for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
      years.push(i);
    }
    return (
      <div className="DayPicker-Caption">
        <select
          ref={reff}
          name="month"
          onChange={this.handleOnChange}
          value={this.state.month}
          style={{
            width: '47%',
            display: 'inline-block',
            padding: '0.15em',
            marginRight: '0.25em',
          }}
        >
          {months.map((month, i) => {
            if (monthLogic && monthLogic({ year: this.state.year, currentMonth, currentYear, month: i })) {
              return '';
            }
            return (
              <option key={month} value={i}>
                {month}
              </option>
            );
          })}
        </select>
        <select
          name="year"
          onChange={this.handleOnChange}
          value={this.state.year}
          style={{
            width: '30%',
            display: 'inline-block',
            padding: '0.15em',
          }}
          disabled={years.length < 2}
        >
          {years.map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default class InputBirthdate extends Component {
  static propTypes = {
    date: PropTypes.string,
    onSelectDay: PropTypes.func.isRequired,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    format: PropTypes.string,
    fromMonth: PropTypes.object,
    toMonth: PropTypes.object,
    showMonth: PropTypes.object,
    monthLogic: PropTypes.func,
    disabledDays: PropTypes.shape({
      before: PropTypes.object,
      after: PropTypes.object,
    }),
  }
  static defaultProps = {
    format: 'YYYY-MM-DD',
    fromMonth: new Date(0, new Date().getMonth()),
    toMonth: new Date(),
    disabledDays: {
      after: new Date(),
    },
  }
  static getPropsToState = (props) => {
    const from = props.date ? new Date(props.date) : null;
    let month = props.date ? new Date(props.date) : props.fromMonth;
    if (props.showMonth) {
      month = props.showMonth;
    }
    return {
      from,
      month,
    };
  }
  constructor(props) {
    super(props);
    const state = InputBirthdate.getPropsToState(props);
    this.state = {
      ...state,
      showOverlay: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = InputBirthdate.getPropsToState(nextProps);
    if (!nextProps.disabled) {
      state.showOverlay = false;
    }
    this.setState({ ...state });
  }
  componentWillUnmount() {
    clearTimeout(this.clickTimeout);
  }

  inputDate = null;

  handleInputClick = () => {
    this.setState({
      showOverlay: !this.state.showOverlay,
    }, () => {
      if (!this.state.showOverlay) {
        this.inputDate.blur();
      }
    });
  }
  handleDayClick = (day, modifiers = {}) => {
    if (modifiers.disabled) {
      return;
    }
    this.setState({ from: day, showOverlay: false }, () => {
      this.inputDate.blur();
    });
    const { onSelectDay, format } = this.props;
    const currentLocale = getCurrentLocale();
    const date = format ? moment(day).locale(currentLocale).format(format) : moment(day).locale(currentLocale);
    if (onSelectDay) {
      onSelectDay(date);
    }
  }
  handleClose = () => {
    this.setState({ showOverlay: false }, () => {
      this.inputDate.blur();
    });
  }
  handleYearMonthChange = (month) => {
    this.setState({ month });
  }
  render() {
    const { fromMonth, toMonth, monthLogic, disabledDays } = this.props;
    const { from, showOverlay } = this.state;

    // 3. Extract the active i18n language string right here
    const currentLocale = getCurrentLocale();
    const localizedWeekdays = moment.localeData(currentLocale).weekdaysMin();

    return (
      <div className={this.props.disabled ? 'disabled field' : 'field'} onMouseDown={this.handleContainerMouseDown}>
        {this.props.label ?
          <label htmlFor="birthdate">{this.props.label}</label>
          : ''
        }
        <div className="ui fluid icon input">
          <input
            name="birthdate"
            type="text"
            ref={(el) => { this.inputDate = el; }}
            pattern="(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))"
            placeholder="YYYY-MM-DD"
            value={from ? moment(from).locale(currentLocale).format('YYYY-MM-DD') : ''}
            readOnly
            onClick={!this.props.disabled ? this.handleInputClick : undefined}
            disabled={this.props.disabled}
          />
          <i
            aria-hidden="true"
            onClick={showOverlay ? this.handleClose : undefined}
            className={showOverlay ? 'x icon' : 'calendar icon'}
            style={showOverlay ? { cursor: 'pointer', pointerEvents: 'all' } : {}}
          />
        </div>
        { showOverlay && !this.props.disabled &&
          <div style={{ position: 'relative' }}>
            <div
              style={{
                position: 'absolute',
                background: 'white',
                boxShadow: '0 2px 5px rgba(0, 0, 0, .15)',
                zIndex: '100',
              }}
            >
              <div className="YearNavigation">
                <DayPicker
                  showOutsideDays
                  month={this.state.month}
                  fromMonth={fromMonth}
                  toMonth={toMonth}
                  selectedDays={from}
                  disabledDays={disabledDays}
                  onDayClick={this.handleDayClick}
                  weekdaysShort={localizedWeekdays}
                  captionElement={({ date, localeUtils }) => (
                    <YearMonthForm
                      date={date}
                      localeUtils={localeUtils}
                      onChange={this.handleYearMonthChange}
                      fromMonth={fromMonth}
                      toMonth={toMonth}
                      monthLogic={monthLogic}
                    />
                  )}
                />
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/InputBirthdate.jsx